/**
 * Zero-UI Immersion Manager
 * Enforces the Creative Constitution: Discovery over Navigation.
 * Purges all visible HUD overlays, FPS counters, and menu buttons from default view.
 * The world is 100% pure navigable space.
 */

import { Engine } from '../core/Engine';

export class HUD {
  private engine: Engine;

  constructor() {
    this.engine = Engine.getInstance();
  }

  public init(): void {
    // Zero visible UI elements created by default.
    // Pure, unencumbered pitch-black canvas viewport.
    
    // Developer debug toggle (press 'D' key to inspect FPS silently if needed)
    window.addEventListener('keydown', (e: KeyboardEvent) => {
      if (e.key === 'd' || e.key === 'D') {
        console.log(`[REALITY AUDIT] FPS: ${this.engine.getFPS()} | Active Scene: ${this.engine.getActiveScene().name}`);
      }
    });
  }
}
